var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-more mt-11 mb-3"},[_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.$emit('loadMore', _vm.allItems)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-down")]),_vm._v(" "+_vm._s(_vm.$t("loadMore"))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }